import { Input, Space } from 'antd';
import React, { Fragment } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import {
    BUTTON_ACTION_TYPE,
    ButtonFilterAction,
} from '@app/components/UI/Button';

const OrganizationFilter = ({ onLinkToOr, onChangeKeyWord, onSearch }) => (
    <Fragment>
        {/* Filter */}
        <div className="row">
            <div className="col-lg-12">
                <div className="row">
                    <div className="col-md-6 col-sm-12">
                        <div className="form-group filter-group">
                            <Space.Compact style={{ width: '100%' }}>
                                <Input
                                    style={{ width: '100px', flexShrink: 0 }}
                                    defaultValue="Điều kiện lọc"
                                    disabled
                                />
                                <Input
                                    onChange={onChangeKeyWord}
                                    placeholder="Tìm họ tên, email, điện thoại..."
                                    prefix={<SearchOutlined />}
                                />
                            </Space.Compact>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <div className="form-group">
                            <div className="no-margin">
                                <div className="btn-group">
                                    <ButtonFilterAction
                                        labelButton="Tìm kiếm"
                                        buttonType={BUTTON_ACTION_TYPE.SEARCH}
                                        onClick={onSearch}
                                    />
                                    <ButtonFilterAction
                                        labelButton="Thêm mới"
                                        buttonType={BUTTON_ACTION_TYPE.ADD}
                                        onClick={onLinkToOr}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* /Filter */}
    </Fragment>
);

export default OrganizationFilter;
